const InstitutionWorkers = () => import("./views/InstitutionsWorkers.vue");
const InstitutionWorkerEdit = () => import("./views/InstitutionWorkerEdit.vue");
const InstitutionWorker = () => import("./views/InstitutionWorker.vue");

const route = "/institutionsWorkers";

export default [
  {
    path: route,
    name: "institutionsWorkers.list",
    component: InstitutionWorkers,
    props: (route) => ({ userId: route.query.userId }),

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "institutionsWorkers.create",
    component: InstitutionWorkerEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:institutionWorkerId`,
    name: "institutionsWorkers.details",
    component: InstitutionWorker,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:institutionWorkerId/edit`,
    name: "institutionsWorkers.edit",
    component: InstitutionWorkerEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
